import React, { useEffect, useState } from 'react';
import { Routes, Route } from 'react-router-dom';
import ListingOverview from './components/listing-overview/ListingOverview';
import TokenPage from './components/tokenpage/TokenPage';
import Header from './components/header/Header';
import List from './components/list/List';
import Advertise from './components/advertise/Advertise';
import SideBar from './components/sidebar/SideBar';
import './App.css';
import { ToastContainer } from 'react-toastify';
import desktopVideo from './assets/desktop.webm';
import mobileVideo from './assets/mobile.webm';

const MOBILE_QUERY = '(max-width: 750px)';

const App: React.FC = () => {
  const [isMobile, setIsMobile] = useState(() =>
    typeof window !== 'undefined' ? window.matchMedia(MOBILE_QUERY).matches : false
  );

  useEffect(() => {
    const media = window.matchMedia(MOBILE_QUERY);
    const handleChange = (e: MediaQueryListEvent) => setIsMobile(e.matches);
    setIsMobile(media.matches);
    media.addEventListener('change', handleChange);
    return () => media.removeEventListener('change', handleChange);
  }, []);

  return (
    <div className="wrapper-full">
      <div className="sidebar-left">
        <SideBar />
      </div>

      <div className="main-right">
        <div className="mainscroll-frame">
          <Header />

          <div className="scrollable-frame">
            <Routes>
              <Route path="/" element={<ListingOverview />} />
              <Route path="/overview" element={<ListingOverview />} />
              <Route path="/:chain/:address" element={<TokenPage />} />
              <Route path="/list" element={<List />} />
              <Route path="/advertise" element={<Advertise />} />
            </Routes>

            {/* <a
              href="https://minotaurus.io/?utm_source=app.coinsult.net&utm_medium=N_C_B_T&utm_campaign=w7jopq7102"
              target="_blank"
              rel="noreferrer"
              className="banner-wrap"
            >
              <video
                autoPlay
                muted
                loop
                playsInline
                className="banner-iframe"
              >
                <source
                  src={isMobile ? mobileVideo : desktopVideo}
                  type="video/webm"
                />
              </video>
            </a> */}
          </div>
        </div>
      </div>

      <ToastContainer />
    </div>
  );
};

export default App;